export default __webpack_public_path__ + "static/contacter-engager-avocats-granby-soumissions-litige-768x512-e554afdbb40afb554ef30e28e8d03298.jpg";